export default __webpack_public_path__ + "static/media/save-sna.a7ca24df.svg";